import ACTIONS from "../constants/actions";

const {
  GET_USER_SHIFT_TYPES_REQUEST,
  GET_USER_SHIFT_TYPES_SUCCESS,
  GET_USER_SHIFT_TYPES_FAIL,
  POST_USER_SHIFT_TYPES_SUCCESS,
  POST_USER_SHIFT_TYPES,
  POST_USER_SHIFT_TYPES_FAIL,
  DELETE_USER_SHIFT_TYPES,
  DELETE_USER_SHIFT_TYPES_FAIL,
  INSERT_SHIFT_TYPES,
  INSERT_SHIFT_TYPES_SUCCESS,
  INSERT_SHIFT_TYPES_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingGetUserShiftTypes: false,
  isLoadingPostUserShiftTypes: false,
  userShiftTypes: [],
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_USER_SHIFT_TYPES:
    case GET_USER_SHIFT_TYPES_REQUEST:
      return {
        ...state,
        isLoadingGetUserShiftTypes: true,
      };
    case GET_USER_SHIFT_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingGetUserShiftTypes: false,
        userShiftTypes: action.payload,
      };
    case DELETE_USER_SHIFT_TYPES_FAIL:
    case INSERT_SHIFT_TYPES:
      return {
        ...state,
        isLoadingGetUserShiftTypes: true,
      };
    case INSERT_SHIFT_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingGetUserShiftTypes: false,
      };
    case INSERT_SHIFT_TYPES_FAIL:
      return {
        ...state,
        isLoadingGetUserShiftTypes: false,
      };
    case GET_USER_SHIFT_TYPES_FAIL:
      return {
        ...state,
        isLoadingGetUserShiftTypes: false,
      };
    case POST_USER_SHIFT_TYPES:
      return {
        ...state,
        isLoadingPostUserShiftTypes: true,
      };
    case POST_USER_SHIFT_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingPostUserShiftTypes: false,
      };
    case POST_USER_SHIFT_TYPES_FAIL:
      return {
        ...state,
        isLoadingPostUserShiftTypes: false,
      };

    default:
      return state;
  }
};
export default calendarReducer;
